import React from 'react';
import styled from 'styled-components/macro';
import useTranslations from '../../hooks/useTranslations';
import GeneralDialog from '../../internal-components/GeneralDialog';
import TextEditorEngine from '../engine/TextEditorEngine';
import Button from '../Button';
import ThankYouEngine from '../form/engine/ThankYouEngine';

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  & > div {
    flex: 1;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 0.8rem;
  justify-content: flex-end;
`;

const FormBuilderCustomizationView = props => {
  const t = useTranslations();
  return (
    <>
      <TextContainer>
        <TextEditorEngine
          editorText={props.message}
          editorHeight={200}
          onChange={props.setMessage}
          additionalPlaceHolders={props.additionalPlaceholders}
        />
      </TextContainer>
      <ButtonContainer>
        <Button
          size="small"
          variant="outlined"
          onClick={() => props.setOpen(true)}
        >
          {t('form-builder.share.viewPreview')}
        </Button>
        <Button size="small" onClick={props.onSaveBtnClicked}>
          {t('form-builder.share.save')}
        </Button>
      </ButtonContainer>
      <GeneralDialog
        open={props.open}
        handleClose={() => props.setOpen(false)}
        buttons={[]}
      >
        <ThankYouEngine contentMsg={props.message} displayLinks={false} />
      </GeneralDialog>
    </>
  );
};

export default FormBuilderCustomizationView;
